import React from 'react'
import { Box, Typography, Button} from "@mui/material";
import productSubscribed from '../../img/products/productSubscribed.png';
import { useNavigate } from 'react-router-dom';
import { colors } from '../../Theme/tokens';

export default function SuccessSubscribed() {
    const navigate = useNavigate()
    return(
        <Box sx={{ backgroundColor: 'white', pb: 3,  borderRadius: '18px', }}>
            <Box  height='auto'>
                <Box sx={{backgroundColor: 'white', minHeight:"calc(100vh - 164px)", display:"flex", justifyContent:"center", alignItems:"center", padding: {sm: '20px 33px 35px 33px',xs: '20px 15px 35px 15px'},borderRadius: '18px'}}>
                    <Box sx={{display:"flex", justifyContent:"center", alignItems:"center", gap:"20px", flexDirection:"column"}}>
                        <Box component='img' sx={{maxWidth:{xs:"150px",sm:"224.13px"}, minWidth:{xs:"150px",sm:"224.13px"}}} src={productSubscribed} />
                        <Box sx={{display:"flex", flexDirection:"column", gap:"10px"}}>
                            <Typography sx={{fontSize:{xs:'20px', sm:'28.82px'}, color: colors.text.primary,  fontWeight:'500', lineHeight:'41.25px', textAlign:"center" }}>Product Subscribed Successfully</Typography>
                            <Typography sx={{fontSize:{xs:'17px', sm:'17.21px'}, color: colors.text.secondary,  fontWeight:'400', lineHeight:'26.9px', textAlign:"center" }}>Your product has been subscribed.</Typography>
                        </Box>
                        <Button onClick={() => navigate('/Products')} sx={{maxWidth:"393px", mt:'10px',width:'100%', fontSize: '15px', height: '42px', padding: '2px 20px 2px 20px', borderRadius: '8px !important', letterSpacing: '.6px', p:"10px", color: colors.primary.contrastText, backgroundColor: colors.primary.main, '&:hover': {backgroundColor: colors.primary.main} }} >
                        Explore More Products
                        </Button>
                    </Box>
                    
                </Box>
            </Box>
        </Box>
    )
}